import { render } from "./Create.vue?vue&type=template&id=04c14548"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=04c14548&lang=css"
script.render = render

export default script